import { SxProperties } from '@bvi/mui-theme';

export const styles = {
  wrapper: {
    paddingLeft: 3,
    paddingRight: 3,
  },
  titleRow: {
    mt: 2,
    mb: 3,
  },
  caseHadingBoxWrapper: {
    backgroundColor: '#fdebc3',
    padding: '16px 14px',
    borderRadius: '5px',
    boxShadow: '1px 3px 4px rgba(0, 0, 0, 0.15)',
  },
  filterFieldColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  filterFieldExcludeRow: {
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    mt: 0.5,
  },
  orgRow: {
    alignItems: 'flex-start',
  },
  yearSelects: {
    display: 'flex',
    gap: 1,
    width: '100%',
  },
  submitBelowYears: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 1.5,
  },
} satisfies SxProperties;
